export const DEFAULT_MODULE = {
  id: 'default',
  name: 'Default Module',
  description:
    'Basic features available to all accounts. Subscribe to specialized modules to unlock additional features.',
  icon: 'apps',
  features: [],
};

export const AVAILABLE_MODULES = [
  {
    id: 'healthcare',
    name: 'Healthcare Module',
    description:
      'Comprehensive healthcare management features including promotions and condition tracking for medical facilities.',
    icon: 'stethoscope',
    features: [
      {
        key: 'promotion_management',
        title: 'Promotion Management',
        icon: 'ticket',
        description:
          'Manage promotions and e-vouchers with ease and transparency.',
        route: 'organization.promotions',
      },
      {
        key: 'condition_management',
        title: 'Condition Management',
        icon: 'stethoscope',
        description:
          'Manage condition profiles, assignments, and availability with ease and transparency.',
        route: 'organization.conditions',
      },
    ],
  },
  {
    id: 'condo_management',
    // Co-living replaces it: not offered to pick any more. An account that is
    // already on it still sees it (Index.vue's visibleModules).
    legacy: true,
    name: 'Condo Management Module',
    description:
      'Complete condo and property management suite with resident access control and facility booking.',
    icon: 'condo',
    features: [
      {
        key: 'condo_management',
        title: 'Condo Management',
        icon: 'condo',
        description: 'Manage condo residents, facilities, and access control.',
        route: 'condo_management',
      },
    ],
    disabledMenuItems: ['knowledge', 'branches', 'organization'],
  },
  {
    id: 'real_estate',
    name: 'Real Estate Module',
    description:
      'Real estate management features for property listings, viewings, and client management.',
    icon: 'condo',
    features: [],
    // Real Estate has its own catalogue/agents/appointments pages
    // (real_estate.routes.js) that take over these nav slots — see
    // docs/real-estate/be/PRD.md §1/§8: "the portal hides the Appointments
    // page and the whole Organization hub ... for that account." Sidebar.vue
    // reads this list against the account's active module (mirrors
    // condo_management's own use of disabledMenuItems just above). Direct
    // URL access to these routes is separately blocked by
    // helper/moduleGuards.js's withRealEstateRedirect.
    disabledMenuItems: ['appointments', 'branches', 'organization'],
  },
  {
    // `id` must equal the backend's SubscriptionModule.CO_LIVING.
    id: 'co_living',
    name: 'Co-living Module',
    description:
      'Condos, tenants, service team, repair tickets and visit booking for co-living operators.',
    icon: 'condo',
    features: [
      {
        key: 'co_living',
        title: 'Co-living',
        icon: 'condo',
        description:
          'Condos, residents, service team, categories, routing, SLA and calendar.',
        route: 'co_living',
      },
      {
        key: 'co_living_tickets',
        title: 'Tickets',
        icon: 'ticket',
        description: 'Repair tickets and visit booking.',
        route: 'co_living_tickets',
      },
    ],
    // Co-living replaces Condo Management: its pages take over those nav
    // slots, and the old Condo Management item is hidden. Real Estate does the
    // same with Appointments, Branches and Organization.
    disabledMenuItems: [
      'appointments',
      'branches',
      'organization',
      'condo_management',
    ],
  },
];
